import {
  ChatContentEnum,
  ChatDescription,
  ChatInterlocutor,
  DialogType,
  PendingChatDescription,
  SelectedDialogInfo,
} from 'types/chatsType';
import { ChatType } from 'types/stateTypes';
import {
  applySelectedDialogInfoToListItem,
  createChatListItemFromSelectedDialogInfo,
  sortChatsByPinAndLastMessage,
} from 'utils/chats.utils.typed';

export const buildPendingChatDescription = (interlocutor: ChatInterlocutor): PendingChatDescription => ({
  firstMessageId: 0,
  image: interlocutor.image,
  index: 0,
  interlocutor,
  isBlocked: false,
  isPinned: false,
  messageId: 0,
  name: null,
  notificationsDisable: false,
  status: interlocutor.status,
  type: DialogType.chat,
  unreadMessageCount: 0,
});

export const buildPendingSelectedDialogInfo = (interlocutor: ChatInterlocutor): SelectedDialogInfo =>
  ({
    image: interlocutor.image,
    interlocutor,
    name: null,
    type: DialogType.chat,
  } as SelectedDialogInfo);

export const isPendingChat = (state: Pick<ChatType, 'selectedDialogInfo' | 'selectedChatId'>): boolean =>
  state.selectedChatId === null && Boolean(state.selectedDialogInfo?.interlocutor);

export const findDialogByPeerId = (chats: ChatDescription[], userId: string): ChatDescription | undefined =>
  chats.find((chat) => chat.interlocutor?.userId === userId && !chat.isDeleted);

export const applySelectChat = (state: ChatType, id: number | null): ChatType => ({
  ...state,
  chatInfo: [],
  hasMoreSearchInDialog: false,
  isChatOpen: id !== null,
  loadingByPeer: false,
  loadingSearchInDialog: false,
  searchInDialogQuery: null,
  searchMessageResult: [],
  selectedChatId: id,
  selectedMessages: [],
  selectionMode: false,
});

export const applyDialogInfoSuccess = (state: ChatType, payload: SelectedDialogInfo): ChatType => {
  const chatIdx = state.chats.findIndex((chat) => chat.id === payload.id);

  if (chatIdx !== -1) {
    const updatedChats = state.chats.map((chat, idx) =>
      idx === chatIdx ? applySelectedDialogInfoToListItem(chat, payload) : chat
    );
    return { ...state, chats: updatedChats, selectedDialogInfo: payload };
  }

  const newChat = createChatListItemFromSelectedDialogInfo(payload);
  return {
    ...state,
    chats: sortChatsByPinAndLastMessage([newChat, ...state.chats]),
    selectedDialogInfo: payload,
  };
};

export const applyOpenedDialogFromByPeer = (state: ChatType, payload: SelectedDialogInfo): ChatType => {
  const selected = applySelectChat(state, payload.id);
  return { ...applyDialogInfoSuccess(selected, payload), chatContent: ChatContentEnum.chat };
};

export const applyOpenExistingDialog = (state: ChatType, dialogId: number): ChatType => ({
  ...applySelectChat(state, dialogId),
  chatContent: ChatContentEnum.chat,
});
